import { useEffect } from 'react';
import { ERROR_TYPES, UIErrorService } from '../../services/core/error-service';

/**
 * Custom hook that attaches a global error handler to the window object.
 *
 * This hook listens for error events on the window and creates a new UIErrorService
 * with the error event data when an error occurs. It uses the ERROR_TYPES.UNEXPECTED
 * type for the error name. The error handler is automatically removed when the
 * component using this hook is unmounted.
 */
export const useWindowOnError = () => {
  const errorHandler = (event: ErrorEvent) => {
    const { message, filename, lineno, colno, error } = event;
    const { stack } = error || {};

    new UIErrorService({
      name: ERROR_TYPES.UNEXPECTED,
      data: { message, filename, lineno, colno, stack },
    });
  };

  useEffect(() => {
    window.addEventListener('error', errorHandler);

    return () => {
      window.removeEventListener('error', errorHandler);
    };
  }, []);
};
